import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import styles from './Prosthetics.module.scss';
import prostheticsImg from '../../../shared/assets/photo/Prosthetic/prosth.png';
import prostheticsImg_2x from '../../../shared/assets/photo/Prosthetic/prosth_2x.png';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const Prosthetics = () => {
    useGSAP(() => {     
        gsap.to(".prostheticsImg", 
            {  
            duration: 2,          
            border: '2px solid #30AFB8',
            scrollTrigger: {
                trigger: ".prostheticsImg"
        }});
    }, [])

    return ( 
        <div> 
            <Stack
                direction = 'column'
                gap = '16'
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.container}>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>
                        Около 35% взрослых старше 15 лет испытывают дискомфорт из-за внешнего 
                        вида своих зубов. Это в основном связано с отсутствием зубов. 
                </Text>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>                        
                        Зубы – это одни из немногих органов человека, которые не подлежат 
                        регенерации. Поэтому в ортопедической стоматологии применяют методы 
                        искусственного воссоздания зубов - протезирование.  
                        Протезирование используется в случае существенных повреждений в зубном ряду, 
                        травмах или удалении большого количества зубов.              
                </Text>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>                       
                        Здоровые зубы облегчают жевание, пищеварение и речь. Но немало важно, они 
                        придают вашему лицу красивую эстетику. Вы чувствуете себя более уверенно, 
                        когда улыбаетесь, зная, что ваши зубы красивые и правильной формы. 
                </Text>
            </Stack>
            <Stack 
                justifyContent='justifyStart'
                alignItems ='alignCenter'
                className={styles.dark}>
                    <Stack
                        direction = 'column'
                        gap = '16'
                        justifyContent='justifyStart'
                        alignItems ='alignCenter'
                        className={styles.content}>   
                            <Text                             
                                size ='xl'
                                className={styles.textTitle}>
                                    Протезирование                            
                            </Text>                       
                            <Text                             
                                size ='m'
                                className={styles.text}>                       
                                    Зубные протезы предназначены для замены отсутствующих зубов.
                                    Существует три основные категории зубных протезов: несъемные, 
                                    съемные и протезы с опорой на имплантаты.                          
                            </Text>

                            <Text                             
                                size ='m'
                                className={styles.text}>               
                                    Протезирование применяют в качестве защитного покрытия для сильно 
                                    разрушенных или сломанных зубов.
                                    Для постоянной реставрации зубов с большими пломбами.
                                    Для исправления незначительных проблем, 
                                    таких как расстояние между зубами, неправильная форма или сильное изменение цвета.
                            </Text>
                    </Stack>
                    <div className={styles.imgContainer}>
                        <img className={`prostheticsImg ${styles.picture}`} src={prostheticsImg}
                                srcSet={`${prostheticsImg_2x} 2x`} alt="протезирование" />
                    </div>
            </Stack>
        </div>
    );
}
export default Prosthetics;